module.exports = __webpack_public_path__ + "img/salty-3.a3dd6302.webp";